import { createGenericDispatcher } from '../../action/action-dispatcher-factory';

import * as Api from '../../api/api';

export const createReferral = (referral: ReferralCreateRequest) =>
  createGenericDispatcher({
    name: 'CREATE_REFERRAL',
    loadFunction: () =>
      Api.post('/referral', {
        body: JSON.stringify(referral),
      }),
    args: referral,
  });
